import classNames from 'classnames';
import { PropsWithChildren } from 'react';

interface StatusContainerProps extends PropsWithChildren {
  variant: 'success' | 'danger' | 'warning' | 'info';
  className?: string;
}

function StatusContainer({ variant, className, children }: StatusContainerProps) {
  return (
    <div
      className={classNames(
        'rounded-md',
        variant === 'success' && 'bg-green-100 text-green-800',
        variant === 'danger' && 'bg-red-100 text-red-800',
        variant === 'warning' && 'bg-yellow-100 text-yellow-800',
        variant === 'info' && 'bg-blue-100 text-blue-800',
        className
      )}
    >
      {children}
    </div>
  );
}

interface StatusContainerErrorProps {
  className?: string;
  error: Error;
}

function StatusContainerError({ error, className }: StatusContainerErrorProps) {
  return (
    <StatusContainer variant="danger" className={className}>
      <div className="font-semibold">Failed to fetch data. {error.message}</div>
    </StatusContainer>
  );
}

StatusContainer.Error = StatusContainerError;

export default StatusContainer;
